import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { IPartnerConfig, parseArray, PartnerConfig } from '@interticket/core';
import { IPartnerSource } from '@core/interfaces/partner/partner-source.interface';
import { Contact } from '@core/models/contact/contact.model';
import { IContact } from '@core/interfaces/contact/contact.interface';
import { StoreService } from '../store/store.service';
import { IOnlinePartner } from '@core/interfaces/partner/online-partner.interface';
import { OnlinePartner } from '@core/models/partner/online-partner.model';

@Injectable()
export class PartnerService {

  private contacts$: Observable<Contact[]>;

  constructor(
    private partnerSourceService: IPartnerSource,
    private storeService: StoreService
  ) { }

  private loadContacts(): Observable<Contact[]> {
    return this.partnerSourceService.getContacts()
      .pipe(
        take(1),
        map((iContacts: IContact[]) => parseArray<IContact, Contact>(iContacts, Contact)),
        tap((contacts: Contact[]) => this.contacts$ = of(contacts))
      );
  }

  getConfig(): Observable<PartnerConfig> {
    return this.partnerSourceService.getConfig()
      .pipe(
        take(1),
        map((iPartnerConfig: IPartnerConfig) => new PartnerConfig(iPartnerConfig)),
        tap(partnerConfig => this.storeService.partnerConfig = partnerConfig)
      );
  }

  getContacts(): Observable<Contact[]> {
    return this.contacts$ || this.loadContacts();
  }

  getOnlinePartnerList(): Observable<OnlinePartner[]> {
    return this.partnerSourceService.getOnlinePartnerList()
      .pipe(
        take(1),
        map((iOnlinePartners: IOnlinePartner[]) => parseArray(iOnlinePartners, OnlinePartner))
      );
  }

}
